var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-upload',{staticClass:"upload-card",attrs:{"drag":"","action":"wwm","multiple":"","show-file-list":false,"http-request":_vm.uploadSectionFile}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("上传文件")]),_vm._v(" "),_c('span',[_vm._v("点击或将文件拖拽到这里上传")]),_vm._v(" "),_c('span',[_vm._v("支持拓展名：.rar .zip .doc .docx .pdf .jpg...")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffd91682","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/special/upload3.vue
// module id = null
// module chunks = 